import { DatabaseStats } from '../../components/admin/DatabaseStats';

export const AdminDashboard = () => {
  return (
    <div className="flex flex-col gap-10">
      <DatabaseStats />
    </div>
  );
};
